import { request } from '@langlois/request';

export async function getBySubscriberId ({ commit }, { instanceId }) {
	const url = new URL(`${process.env.VUE_APP_API_URI}/club/subscription?instanceId=${instanceId}&product=club_owner`);

	let response;

	try {
		response = await request.get(url);

		const { ok } = response;

		if (!ok) {
			return commit(`vcl/notificationBar/show`, {
				text: `Encountered an error while retrieving the subscriptions.`,
				type: `warning`
			}, { root: true });
		}

		const subscription = await response.json();

		commit(`setSubscription`, subscription);
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the subscriptions.`,
			type: `warning`
		}, { root: true });
	}
}
